"use client";

import { c as _c } from "react/compiler-runtime";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, LogarithmicScale } from "chart.js";
import levels from "@/constants/levels.json";
import { useEffect, useState } from "react";
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, LogarithmicScale);
interface LevelData {
  level: number;
  threshold: number;
}
export default function ProgressChart() {
  const $ = _c(12);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (typeof window !== "undefined") {
        setPrefersReducedMotion(window.matchMedia("(prefers-reduced-motion: reduce)").matches);
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = (levels as LevelData[]).map(_temp);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = (levels as LevelData[]).map(_temp2);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      labels: t2,
      datasets: [{
        label: "TDH + Rep",
        data: t3,
        fill: "start" as const,
        tension: 0.15,
        borderColor: "#84ADFF",
        backgroundColor: "rgba(132, 173, 255, 0.2)",
        pointRadius: 0,
        pointHoverRadius: 4
      }]
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const data = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      grid: {
        color: "rgba(255,255,255,0.1)"
      },
      ticks: {
        color: "#E5E5E5"
      }
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      x: t5,
      y: {
        type: "logarithmic" as const,
        grid: {
          color: "rgba(255,255,255,0.1)"
        },
        ticks: {
          color: "#E5E5E5"
        }
      }
    };
    t7 = {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: _temp3
        }
      }
    };
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  const t8 = prefersReducedMotion ? false as const : undefined;
  let t9;
  if ($[8] !== t8) {
    t9 = {
      responsive: true,
      maintainAspectRatio: false,
      scales: t6,
      plugins: t7,
      animation: t8,
      onHover: _temp4
    };
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const options = t9;
  let t10;
  if ($[10] !== options) {
    t10 = <div className="tw-h-[180px] tw-w-full md:tw-h-[280px]"><Line data={data} options={options} /></div>;
    $[10] = options;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  return t10;
}
function _temp4(_, activeElements) {
  if (activeElements.length > 0) {
    const idx = activeElements[0].index;
    const level = (levels as LevelData[])[idx]?.level;
    window.dispatchEvent(new CustomEvent("level-hover", {
      detail: {
        level
      }
    }));
  }
}
function _temp3(ctx) {
  return `Level ${ctx.label}: ${ctx.parsed.y.toLocaleString()} TDH+Rep`;
}
function _temp2(l_0) {
  return l_0.threshold;
}
function _temp(l) {
  return l.level;
}